import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosCommonInstance from "../../../utils/axios/axiosCommonInstance";
import "@google/model-viewer";
import Toggle from 'react-toggle'
import 'react-toggle/style.css'

const ViewarView = () => {
  const { id } = useParams();
  const [arView, setArView] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedColor, setSelectedColor] = useState("#ffffff");
  const [colors, setColors] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [colorMaterial, setColorMaterial] = useState(null);
  const [hasAnimations, setHasAnimations] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const fetcharViewData = async () => {
    try {
      const response = await axiosCommonInstance.get(`arview/detail/${id}`);
      if (response.status === 200) {
        const { image, colors, selectedMaterial } = response.data.result;
        setArView(image);
        setColorMaterial(selectedMaterial);
        if (colors && colors.length > 0) {
          setColors(colors);
        }
      }
    } catch (error) {
      console.error("Error fetching arView data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetcharViewData();
  }, [id]);

  const handleColorChange = (color) => {
    setSelectedColor(color);
  };

  const applyColor = async () => {
    const modelViewer = document.querySelector("model-viewer");

    if (modelViewer && modelViewer.model) {
      for (let index = 0; index < modelViewer.model.materials.length; index++) {
        const material = modelViewer.model.materials[index];

        try {
          // Ensure the material is fully loaded before accessing its properties
          if (material && typeof material.ensureLoaded === 'function') {
            await material.ensureLoaded();
          }

          if (colorMaterial == index) {
            if (material && material.pbrMetallicRoughness) {
              material.pbrMetallicRoughness.setBaseColorFactor(selectedColor);
            } else {
              console.warn(`Material ${index} does not support PBR.`);
            }
          } else {
            // Reset to default color for non-selected materials
            if (material && material.pbrMetallicRoughness) {
              material.pbrMetallicRoughness.setBaseColorFactor("#fff");
            }
          }
        } catch (error) {
          console.error(`Failed to load material ${index}:`, error);
        }
      }
    } else {
      console.log("Model viewer not found.");
    }
  };

  useEffect(() => {
    applyColor();
  }, [selectedColor, colorMaterial]);

  useEffect(() => {
    const modelViewer = document.querySelector("model-viewer");
    if (modelViewer) {
      modelViewer.addEventListener("load", () => {
        if (modelViewer.model) {
          const materials = modelViewer.model.materials.map((mat, index) => ({
            label: mat.name || `Material ${index + 1}`,
            value: index,
          }));
          setMaterials(materials);

          if (modelViewer.availableAnimations && modelViewer.availableAnimations.length > 0) {
            setHasAnimations(true);
          } else {
            setHasAnimations(false);
          }

          // Automatically select the first material if there is only one
          if (materials.length === 1) {
            setColorMaterial(materials[0].value); // Set the first material
          }
        } else {
          console.error("Model materials not found.");
        }
      });
    }
  }, [arView]);

  const handleToggleAnimation = () => {
    const modelViewer = document.querySelector("model-viewer");
    if (modelViewer) {
      if (isPlaying) {
        modelViewer.pause();
      } else {
        modelViewer.play();
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!arView) {
    return <div>No AR View data found.</div>;
  }

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center bg-gray-900">
      <model-viewer
        src={arView}
        alt="3D model"
        auto-rotate
        camera-controls
        ar
        ar-modes="webxr scene-viewer quick-look"
        style={{ width: "100%", height: "500px" }}
      ></model-viewer>

      {hasAnimations &&
        <div className="mt-4">
          <Toggle
            checked={isPlaying}
            onChange={() => {
              setIsPlaying(!isPlaying);
              handleToggleAnimation();
            }}
            icons={false}
          />
        </div>
      }

      {materials.length > 0 && colors.length > 0 && (
        <>
          <div className="mt-4 flex flex-wrap gap-4 justify-center items-center" style={{ maxWidth: '250px' }}>
            {colors.map((color) => (
              <button
                key={color._id}
                className="w-10 h-10 rounded-full border-2 border-white"
                style={{ backgroundColor: color.code }}
                onClick={() => handleColorChange(color.code)}
              ></button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ViewarView;
